import { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { putAiPrompt } from "../../connections/putAiPrompt";

const UpdateAiPrompt = () => {
  const {
    user: { user },
  } = useSelector((store) => store);

  const [formState, setFormState] = useState({
    key: "",
    text_prompt: "",
  });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const aiPromptData = location.state || null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdateAiPrompt = async (e) => {
    e.preventDefault();

    if (!formState.key?.trim() || !formState.text_prompt?.trim()) {
      toast.error("Key and text prompt are required");
      return;
    }

    if (!aiPromptData?.id) {
      toast.error("AI Prompt ID not found");
      return;
    }

    const payload = new FormData();
    payload.append("ai_prompt_content[key]", formState.key);
    payload.append("ai_prompt_content[text_prompt]", formState.text_prompt);

    try {
      setLoading(true);

      const data = await putAiPrompt(user?.token, payload, aiPromptData.id);

      if (data?.status?.status === "SUCCESS") {
        toast.success("AI Prompt updated successfully");
        navigate("/admin/ai-prompts");
      } else {
        toast.error(data?.status?.message || "Failed to update AI Prompt");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (aiPromptData) {
      setFormState({
        key: aiPromptData?.key || "",
        text_prompt: aiPromptData?.text_prompt || "",
      });
    }
  }, [aiPromptData]);

  return (
    <>
      <Header />
      <Sidebar activeClassName="ai-prompts" />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin/ai-prompts">AI Prompts</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Update AI Prompt</li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">{aiPromptData?.id}</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleUpdateAiPrompt}>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-heading">
                          <h4>Update AI Prompt</h4>
                        </div>
                      </div>

                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>
                            Key
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            value={formState.key}
                            name="key"
                            onChange={handleChange}
                            className="form-control"
                            type="text"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="form-group local-forms">
                          <label>
                            Text Prompt
                            <span className="login-danger">*</span>
                          </label>
                          <textarea
                            value={formState.text_prompt}
                            name="text_prompt"
                            onChange={handleChange}
                            className="form-control"
                            rows={12}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="doctor-submit text-end">
                          <button
                            type="submit"
                            className="btn btn-primary submit-form me-2"
                            disabled={loading}
                          >
                            {loading ? "Updating..." : "Update AI Prompt"}
                          </button>

                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              navigate("/admin/ai-prompts");
                            }}
                            type="button"
                            className="btn btn-primary cancel-form"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="notification-box">
          <div className="msg-sidebar notifications msg-noti">
            <div className="topnav-dropdown-header">
              <span>Messages</span>
            </div>
            <div className="drop-scroll msg-list-scroll" id="msg_list">
              <ul className="list-box">
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">R</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Richard Miles </span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item new-message">
                      <div className="list-left">
                        <span className="avatar">J</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">John Doe</span>
                        <span className="message-time">1 Aug</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">T</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Tarah Shropshire</span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="#">
                    <div className="list-item">
                      <div className="list-left">
                        <span className="avatar">M</span>
                      </div>
                      <div className="list-body">
                        <span className="message-author">Mike Litorus</span>
                        <span className="message-time">12:28 AM</span>
                        <div className="clearfix" />
                        <span className="message-content">
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                        </span>
                      </div>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="topnav-dropdown-footer">
              <Link to="#">See all messages</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateAiPrompt;
